import { createSlice } from '@reduxjs/toolkit'
import { CryptoUtils } from 'src/utils/Crypto.utils'
import { ResponseDataBody } from 'src/types/websocket'

const initialState: ResponseDataBody.CurrentLocation = {
  XVal: '',
  YVal: '',
  Address: '',
  Date: null,
}

const currentLocationSlice = createSlice({
  name: 'currentLocation',
  initialState,
  reducers: {
    setCurrentLocation(state, action) {
      const { XVal, YVal, Address, Date } = action.payload
      state.XVal = CryptoUtils.DecryptData(XVal)
      state.YVal = CryptoUtils.DecryptData(YVal)
      state.Address = Address === '' ? '' : CryptoUtils.DecryptData(Address)
      state.Date = Date
    },
  },
})

export const { setCurrentLocation } = currentLocationSlice.actions

export default currentLocationSlice.reducer
